import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './assets/css/app.scss';
import VueFriendlyIframe from 'vue-friendly-iframe';
import { i18n } from './plugins/i18n';
import './plugins/vee-validate';
import './plugins/abilityPlugin';
import PortalVue from 'portal-vue';

Vue.use(VueFriendlyIframe);
Vue.use(PortalVue);

const VueUploadComponent = require('vue-upload-component');
Vue.component('file-upload', VueUploadComponent);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
